var _path, _path2, _g, _g2, _g3, _path3, _g4, _g5, _g6, _g7, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _circle2, _path11, _circle3, _path12, _circle4, _path13, _circle5, _path14, _circle6, _path15, _circle7, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvBottle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 220,
    viewBox: "0 0 370 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.816 49.4399L234.442 48V137.227L230.816 138.667V49.4399Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.441 48L238.585 51.8377V141.065L234.441 137.227V48Z",
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9008_207203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.386 112.272V136.499L232.316 148.615L232.316 124.376L253.386 112.272Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.246 112.271L231.316 124.304V148.616L210.246 136.501V112.271Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.318 116.936L210.748 111.41L231.815 99.2961L241.252 104.77L220.318 116.936Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.879 111.41L231.815 123.521L221.16 117.433L242.003 105.21L252.879 111.41Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9008_207203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.386 127.272V151.499L257.316 163.615L257.316 139.376L278.386 127.272Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.246 127.271L256.316 139.304V163.616L235.246 151.501V127.271Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.318 131.936L235.748 126.41L256.815 114.296L266.252 119.77L245.318 131.936Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.879 126.41L256.815 138.521L246.16 132.433L267.003 120.21L277.879 126.41Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9008_207203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.386 156.272V180.499L308.316 192.615L308.316 168.376L329.386 156.272Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.246 156.271L307.316 168.304V192.616L286.246 180.501V156.271Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.318 160.936L286.748 155.41L307.815 143.296L317.252 148.77L296.318 160.936Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.879 155.41L307.815 167.521L297.16 161.433L318.003 149.21L328.879 155.41Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.183 94.0977L203.623 108.601L308.252 169.721L337 152.628L234.183 94.0977Z",
    fill: "#D9D9D9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_9008_207203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.386 82.272V106.499L231.316 118.615L231.316 94.3755L252.386 82.272Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.246 82.2715L230.316 94.3038V118.616L209.246 106.501V82.2715Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.318 86.9356L209.748 81.4098L230.815 69.2961L240.252 74.7704L219.318 86.9356Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.879 81.4095L230.815 93.5215L220.16 87.4327L241.003 75.2104L251.879 81.4095Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_9008_207203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.386 97.272V121.499L256.316 133.615L256.316 109.376L277.386 97.272Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.246 97.2715L255.316 109.304V133.616L234.246 121.501V97.2715Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.318 101.936L234.748 96.4098L255.815 84.2961L265.252 89.7704L244.318 101.936Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.879 96.4095L255.815 108.521L245.16 102.433L266.003 90.2104L276.879 96.4095Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_9008_207203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.386 111.272V135.499L282.316 147.615L282.316 123.376L303.386 111.272Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.246 111.271L281.316 123.304V147.616L260.246 135.501V111.271Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.318 115.936L260.748 110.41L281.815 98.2961L291.252 103.77L270.318 115.936Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.879 110.41L281.815 122.521L271.16 116.433L292.003 104.21L302.879 110.41Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_9008_207203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.386 126.272V150.499L307.316 162.615L307.316 138.376L328.386 126.272Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.246 126.271L306.316 138.304V162.616L285.246 150.501V126.271Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.318 130.936L285.748 125.41L306.815 113.296L316.252 118.77L295.318 130.936Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.879 125.41L306.815 137.521L296.16 131.433L317.003 119.21L327.879 125.41Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.811 60.4711L205.436 59.0312V153.057L201.811 149.699V60.4711Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.811 60.4707L205.954 64.3084V153.536L201.811 149.698V60.4707Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.512 114.68L312.137 113.24V201.028L308.512 203.907V114.68Z",
    fill: "#8C8C8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304.367 112.52L308.511 114.678V203.906L304.367 201.747V112.52Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337 105.805L331.82 102.926V189.515L337 191.194V105.805Z",
    fill: "#8C8C8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M332.855 107.963L336.999 105.805V191.194L332.855 192.873V107.963Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 101.5,
    r: 8.5,
    stroke: "#00C108",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M221.626 96.3514V106.533H218.862V98.8968H218.802L216.575 100.229V97.8826L219.08 96.3514H221.626Z",
    fill: "#00C108"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.5,
    cy: 115.5,
    r: 8.5,
    stroke: "#00C108",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M241.65 120.533V118.545L245.448 115.403C245.7 115.194 245.916 114.998 246.095 114.816C246.277 114.63 246.416 114.44 246.512 114.244C246.612 114.049 246.661 113.831 246.661 113.593C246.661 113.331 246.605 113.107 246.492 112.922C246.383 112.736 246.231 112.594 246.035 112.494C245.839 112.391 245.614 112.34 245.359 112.34C245.104 112.34 244.878 112.391 244.683 112.494C244.491 112.597 244.341 112.748 244.235 112.947C244.129 113.145 244.076 113.387 244.076 113.672H241.451C241.451 112.956 241.612 112.34 241.933 111.823C242.255 111.306 242.709 110.908 243.296 110.63C243.882 110.351 244.57 110.212 245.359 110.212C246.174 110.212 246.88 110.343 247.477 110.605C248.077 110.863 248.539 111.228 248.864 111.699C249.192 112.169 249.356 112.721 249.356 113.354C249.356 113.745 249.275 114.135 249.112 114.523C248.95 114.907 248.658 115.333 248.237 115.8C247.817 116.268 247.218 116.824 246.443 117.471L245.488 118.266V118.326H249.465V120.533H241.65Z",
    fill: "#00C108"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 129.5,
    r: 8.5,
    stroke: "#00C108",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.429 134.672C269.627 134.672 268.914 134.535 268.291 134.26C267.672 133.981 267.184 133.599 266.83 133.111C266.475 132.624 266.296 132.064 266.293 131.431H269.077C269.08 131.626 269.14 131.802 269.256 131.958C269.375 132.11 269.538 132.23 269.743 132.316C269.949 132.402 270.184 132.445 270.449 132.445C270.704 132.445 270.93 132.4 271.125 132.311C271.321 132.218 271.473 132.09 271.583 131.928C271.692 131.766 271.745 131.58 271.742 131.371C271.745 131.166 271.682 130.983 271.553 130.824C271.427 130.665 271.249 130.541 271.021 130.452C270.792 130.362 270.529 130.317 270.23 130.317H269.196V128.408H270.23C270.505 128.408 270.747 128.363 270.956 128.274C271.168 128.184 271.332 128.06 271.448 127.901C271.568 127.742 271.626 127.56 271.622 127.354C271.626 127.155 271.578 126.98 271.478 126.827C271.379 126.675 271.239 126.555 271.061 126.469C270.885 126.383 270.681 126.34 270.449 126.34C270.197 126.34 269.972 126.385 269.773 126.474C269.577 126.564 269.423 126.688 269.311 126.847C269.198 127.006 269.14 127.189 269.137 127.394H266.492C266.495 126.771 266.666 126.221 267.004 125.743C267.345 125.266 267.812 124.892 268.406 124.62C268.999 124.348 269.68 124.212 270.449 124.212C271.201 124.212 271.866 124.34 272.443 124.595C273.023 124.85 273.475 125.202 273.8 125.649C274.128 126.093 274.29 126.602 274.287 127.175C274.294 127.745 274.098 128.213 273.7 128.577C273.306 128.942 272.806 129.157 272.199 129.224V129.303C273.021 129.393 273.639 129.644 274.053 130.059C274.468 130.47 274.672 130.987 274.665 131.61C274.668 132.206 274.489 132.735 274.128 133.196C273.77 133.657 273.271 134.018 272.632 134.28C271.995 134.541 271.261 134.672 270.429 134.672Z",
    fill: "#00C108"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 144.5,
    r: 8.5,
    stroke: "#00C108",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M291.161 147.942V145.795L295.258 139.351H297.206V142.215H296.093L293.885 145.715V145.795H299.931V147.942H291.161ZM296.113 149.533V147.286L296.172 146.351V139.351H298.758V149.533H296.113Z",
    fill: "#00C108"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 130.5,
    r: 8.5,
    stroke: "#00C108",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M220.57 135.672C219.787 135.672 219.093 135.535 218.486 135.26C217.883 134.981 217.408 134.599 217.06 134.111C216.715 133.624 216.539 133.064 216.533 132.431H219.217C219.227 132.782 219.363 133.062 219.625 133.271C219.89 133.48 220.205 133.584 220.57 133.584C220.851 133.584 221.1 133.525 221.315 133.405C221.531 133.283 221.7 133.11 221.822 132.888C221.945 132.666 222.005 132.408 222.001 132.113C222.005 131.814 221.945 131.556 221.822 131.337C221.7 131.115 221.531 130.944 221.315 130.825C221.1 130.702 220.851 130.641 220.57 130.641C220.278 130.641 220.008 130.712 219.759 130.855C219.514 130.994 219.333 131.188 219.217 131.437L216.791 130.959L217.189 125.351H224.03V127.559H219.456L219.257 129.806H219.317C219.476 129.498 219.751 129.242 220.142 129.04C220.533 128.835 220.987 128.732 221.504 128.732C222.111 128.732 222.651 128.873 223.125 129.155C223.602 129.436 223.978 129.826 224.254 130.323C224.532 130.817 224.669 131.387 224.666 132.033C224.669 132.742 224.5 133.372 224.159 133.922C223.821 134.469 223.345 134.898 222.732 135.21C222.119 135.518 221.398 135.672 220.57 135.672Z",
    fill: "#00C108"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.5,
    cy: 144.5,
    r: 8.5,
    stroke: "#00C108",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M244.639 149.672C244.046 149.672 243.482 149.58 242.949 149.394C242.419 149.205 241.948 148.908 241.537 148.504C241.126 148.1 240.803 147.573 240.567 146.923C240.335 146.273 240.221 145.486 240.224 144.562C240.228 143.736 240.334 142.994 240.543 142.334C240.755 141.675 241.055 141.113 241.442 140.649C241.834 140.185 242.301 139.83 242.844 139.585C243.388 139.336 243.993 139.212 244.659 139.212C245.408 139.212 246.068 139.356 246.638 139.645C247.208 139.933 247.662 140.319 248 140.803C248.341 141.284 248.54 141.814 248.597 142.394H245.872C245.809 142.106 245.663 141.895 245.435 141.763C245.209 141.627 244.951 141.559 244.659 141.559C244.079 141.559 243.653 141.811 243.381 142.314C243.113 142.818 242.975 143.481 242.969 144.303H243.028C243.158 143.992 243.353 143.725 243.615 143.503C243.877 143.281 244.182 143.11 244.53 142.991C244.878 142.871 245.246 142.812 245.633 142.812C246.25 142.812 246.789 142.951 247.249 143.229C247.713 143.508 248.075 143.889 248.333 144.373C248.592 144.857 248.719 145.41 248.716 146.033C248.719 146.762 248.547 147.4 248.199 147.947C247.854 148.494 247.375 148.918 246.762 149.22C246.149 149.522 245.441 149.672 244.639 149.672ZM244.619 147.584C244.894 147.584 245.138 147.521 245.35 147.395C245.566 147.269 245.733 147.097 245.852 146.878C245.975 146.66 246.035 146.411 246.031 146.133C246.035 145.851 245.975 145.602 245.852 145.387C245.733 145.168 245.566 144.996 245.35 144.87C245.138 144.744 244.894 144.681 244.619 144.681C244.417 144.681 244.23 144.717 244.057 144.79C243.888 144.86 243.741 144.961 243.615 145.094C243.489 145.223 243.39 145.377 243.317 145.556C243.247 145.732 243.211 145.924 243.207 146.133C243.211 146.411 243.274 146.66 243.396 146.878C243.519 147.097 243.686 147.269 243.898 147.395C244.111 147.521 244.351 147.584 244.619 147.584Z",
    fill: "#00C108"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 174.5,
    r: 8.5,
    stroke: "#00C108",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M292.36 179.533L296.358 171.618V171.559H291.664V169.351H299.221V171.559L295.204 179.533H292.36Z",
    fill: "#00C108"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0942 65.3432L46.2326 61.2232C46.8363 60.876 47.3268 61.1552 47.3268 61.857V70.0972C47.3268 70.7914 46.8363 71.6441 46.2326 71.9912L39.0942 76.1113C38.4905 76.4584 38 76.1792 38 75.4774V67.2373C38.0075 66.543 38.4905 65.6903 39.0942 65.3432Z",
    fill: "#374A57"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5234 61.6311L46.9949 61.1406L47.9759 61.7066L46.0064 62.4159L45.5234 61.6311Z",
    fill: "#374A57"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2871 76.1568L40 75.5078L40.9885 76.0738L39.3058 76.7378L38.2871 76.1568Z",
    fill: "#374A57"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0238 76.6412L47.1623 72.5211C47.766 72.174 48.2564 71.3288 48.2564 70.6271V62.3869C48.2564 61.6927 47.766 61.4059 47.1623 61.7531L40.0238 65.8731C39.4202 66.2202 38.9297 67.0654 38.9297 67.7672V76.0073C38.9297 76.7015 39.4202 76.9883 40.0238 76.6412Z",
    fill: "#8A9CA8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 63.4269C46.6641 63.6684 46.8301 63.7665 47.0414 63.6457C47.2526 63.525 47.4187 63.2307 47.4187 62.9893C47.4187 62.7478 47.2526 62.6497 47.0414 62.7704C46.8301 62.8912 46.6641 63.1854 46.6641 63.4269Z",
    fill: "#374A57"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 67.4152C39.7578 67.6567 39.9238 67.7548 40.1351 67.634C40.3464 67.5133 40.5124 67.219 40.5124 66.9775C40.5124 66.7361 40.3464 66.638 40.1351 66.7587C39.9314 66.8794 39.7578 67.1737 39.7578 67.4152Z",
    fill: "#374A57"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 71.3214C46.6641 71.5629 46.8301 71.661 47.0414 71.5403C47.2526 71.4195 47.4187 71.1253 47.4187 70.8838C47.4187 70.6423 47.2526 70.5442 47.0414 70.6649C46.8376 70.7857 46.6641 71.08 46.6641 71.3214Z",
    fill: "#3C3C3B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 75.3058C39.7578 75.5473 39.9238 75.6454 40.1351 75.5247C40.3464 75.4039 40.5124 75.1096 40.5124 74.8682C40.5124 74.6267 40.3464 74.5286 40.1351 74.6493C39.9314 74.7701 39.7578 75.0644 39.7578 75.3058Z",
    fill: "#374A57"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9688 70.1278C41.9688 71.1616 42.6932 71.5842 43.5911 71.0635C44.4891 70.5429 45.2135 69.2902 45.2135 68.2565C45.2135 67.2227 44.4891 66.8001 43.5911 67.3208C42.6932 67.8414 41.9688 69.0941 41.9688 70.1278Z",
    fill: "#3C3C3B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4492 70.6923C41.4492 72.3448 42.6113 73.0164 44.045 72.1939C45.4787 71.3638 46.6408 69.3491 46.6408 67.6965C46.6408 66.044 45.4787 65.3724 44.045 66.1949C42.6113 67.0249 41.4492 69.0397 41.4492 70.6923Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3847 73.273C53.9129 73.273 54.4034 72.9259 54.5618 72.3977C54.758 71.7488 54.3883 71.0696 53.7393 70.8734L44.5484 68.1418C43.8994 67.9456 43.3938 68.3229 43.1977 68.9719C43.0015 69.6208 43.1977 70.2999 43.8466 70.4886L53.0375 73.2202C53.1507 73.2579 53.2715 73.273 53.3847 73.273Z",
    fill: "#8A9CA8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5684 72.0504C51.5684 73.5219 52.7606 74.7141 54.2321 74.7141C55.7035 74.7141 56.8958 73.5219 56.8958 72.0504C56.8958 70.579 55.7035 69.3867 54.2321 69.3867C52.7606 69.3867 51.5684 70.579 51.5684 72.0504Z",
    fill: "#374A57"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8515 71.1068C55.4023 71.1068 55.9079 70.7295 56.0437 70.1711L58.0887 61.7046C58.2471 61.0481 57.8396 60.3841 57.1832 60.2256C56.5267 60.0671 55.8626 60.4746 55.7041 61.1311L53.6592 69.5976C53.5007 70.2541 53.9082 70.9182 54.5647 71.0766C54.6628 71.0993 54.7534 71.1068 54.8515 71.1068Z",
    fill: "#8A9CA8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9062 60.2021C53.9062 62.2923 55.6041 63.9902 57.6943 63.9902C59.7845 63.9902 61.4824 62.2923 61.4824 60.2021C61.4824 58.1119 59.7845 56.4141 57.6943 56.4141C55.6041 56.4141 53.9062 58.1119 53.9062 60.2021Z",
    fill: "#374A57"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5513 56.9519L54.7285 44.3503C53.7777 43.7994 52.4723 43.8824 51.0234 44.7125L75.6609 58.9365C76.7852 59.5855 77.902 58.031 76.906 57.201C76.8984 57.1934 76.8909 57.1859 76.8833 57.1859C76.838 57.1481 76.7928 57.118 76.7475 57.0878L76.7173 57.118L76.5513 56.9519Z",
    fill: "#374A57"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8926 48.1161C55.8926 45.1354 53.8024 43.9281 51.2217 45.4222C48.641 46.9087 46.5508 50.5308 46.5508 53.5114C46.5508 56.4921 48.641 57.6994 51.2217 56.2053C53.8024 54.7112 55.8926 51.0892 55.8926 48.1161Z",
    fill: "#8A9CA8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5265 45.0974L47.9238 56.5332L67.404 67.7804L74.0067 56.3446L54.5265 45.0974Z",
    fill: "#8A9CA8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7061 56.665C68.1254 58.1515 66.0352 61.7736 66.0352 64.7542C66.0352 67.7348 68.1254 68.9422 70.7061 67.4481C73.2868 65.9615 75.377 62.3395 75.377 59.3589C75.377 56.3782 73.2868 55.1784 70.7061 56.665ZM73.3547 57.4648C73.8075 57.7289 74.0716 58.4156 74.0716 59.3589C74.0716 60.5587 73.6415 61.9924 72.8793 63.3054C72.1247 64.6184 71.0909 65.7125 70.0571 66.3087C69.2422 66.7765 68.5178 66.8972 68.065 66.6331C67.8613 66.5199 67.7028 66.3162 67.5821 66.0445C67.4312 65.705 67.3557 65.2673 67.3557 64.7466C67.3557 63.5544 67.7934 62.1131 68.548 60.8001C69.3025 59.4871 70.3363 58.393 71.3701 57.7893C71.8229 57.5327 72.2455 57.3743 72.6077 57.3366C72.8944 57.3139 73.151 57.3516 73.3547 57.4648Z",
    fill: "#EDEDED"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0635 59.3564C74.0635 60.5562 73.6334 61.99 72.8713 63.3029C72.1167 64.6159 71.0829 65.7101 70.0491 66.3062C69.2341 66.7741 68.5097 66.8948 68.057 66.6307C67.8532 66.5175 67.6948 66.3138 67.574 66.0421C67.4231 65.7026 67.3477 65.2649 67.3477 64.7442C67.3477 63.552 67.7853 62.1107 68.5399 60.7977C69.2945 59.4847 70.3283 58.3906 71.3621 57.7869C71.8148 57.5303 72.2374 57.3718 72.5996 57.3341C72.8939 57.3039 73.1505 57.3417 73.3542 57.4624C73.807 57.7265 74.0711 58.4207 74.0635 59.3564Z",
    fill: "#374A57"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6002 57.3438C72.238 57.3815 71.8078 57.5399 71.3626 57.7965C71.3249 57.8191 71.2947 57.8418 71.257 57.8644C71.0004 58.0229 70.7439 58.2115 70.4948 58.4228C69.7704 59.0416 69.0913 59.8641 68.548 60.8073C68.0047 61.7506 67.6274 62.7542 67.4614 63.6899C67.401 64.0143 67.3633 64.3313 67.3633 64.6331C67.3633 64.6784 67.3633 64.7161 67.3633 64.7614C67.3633 65.2821 67.4463 65.7273 67.5897 66.0593C68.0349 66.1574 68.631 66.0216 69.2724 65.6744C70.2911 65.116 71.2947 64.0747 72.0191 62.8145C72.7435 61.5544 73.151 60.1659 73.1208 59.0039C73.0906 58.2568 72.902 57.6758 72.6002 57.3438Z",
    fill: "#8A9CA8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2492 57.8574C70.9926 58.0159 70.736 58.2045 70.487 58.4158C69.7626 59.0346 69.0835 59.8571 68.5402 60.8003C67.9969 61.7436 67.6196 62.7472 67.4536 63.6829C67.3932 64.0073 67.3555 64.3243 67.3555 64.6261C67.846 64.8525 68.4949 64.7921 69.2042 64.3771C70.7285 63.4942 71.9736 61.3512 71.9736 59.5854C71.966 58.7629 71.6944 58.1668 71.2492 57.8574Z",
    fill: "#3C3C3B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4866 58.416C69.7622 59.0348 69.083 59.8573 68.5397 60.8005C67.9964 61.7438 67.6191 62.7474 67.4531 63.6831C67.8455 63.9321 68.3964 63.9094 69.0151 63.5548C70.2074 62.8681 71.1657 61.2005 71.1657 59.8271C71.1582 59.1253 70.9016 58.6348 70.4866 58.416Z",
    fill: "#1D1D1B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.4496 62.3092C68.8042 62.1054 69.1589 61.7281 69.4381 61.2754L70.087 61.781C69.7475 62.3167 69.3098 62.7619 68.857 63.0185C68.5099 63.2147 68.1854 63.2977 67.9062 63.2524L68.0496 62.445C68.1175 62.4526 68.2458 62.4299 68.4496 62.3092Z",
    fill: "#EDEDED"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3849 52.3616C48.1887 52.2484 48.0906 51.9541 48.1661 51.7051C48.2415 51.4561 48.4604 51.3429 48.6566 51.4561L65.3934 61.1224C65.5896 61.2356 65.6877 61.5299 65.6122 61.7789C65.5368 62.0279 65.3179 62.1411 65.1218 62.0279L48.3849 52.3616Z",
    fill: "#C6C6C6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9623 54.3783C47.7661 54.2651 47.6227 54.001 47.6378 53.7821C47.6529 53.5633 47.8265 53.4803 48.0226 53.5935L64.7595 63.2598C64.9557 63.373 65.0991 63.6371 65.084 63.856C65.0689 64.0748 64.8953 64.1578 64.6991 64.0446L47.9623 54.3783Z",
    fill: "#C6C6C6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0167 45.0958L74.2615 56.206C73.7207 56.3283 73.1605 56.5545 72.5975 56.8817C71.0569 57.7726 69.6872 59.2701 68.7108 60.9723C68.5223 61.2945 68.3501 61.6234 68.194 61.9512L68.1927 61.954C67.363 63.7245 65.1568 64.3913 63.4398 63.4008C63.4397 63.4008 63.4397 63.4008 63.4396 63.4007L47.0287 53.9239C47.0285 53.9238 47.0283 53.9237 47.0281 53.9236C46.5561 53.6489 46.3011 53.1121 46.3879 52.5804L46.3881 52.5797C46.5883 51.3423 47.0703 50.0563 47.7536 48.8713C48.6718 47.2827 49.9201 45.9295 51.2751 45.1458C52.6343 44.3674 53.7395 44.3538 54.4801 44.7829L54.4801 44.783L54.4879 44.7873C54.5326 44.8121 54.5814 44.8444 54.6269 44.8785L54.9738 45.1387L55.0167 45.0958Z",
    fill: "white",
    stroke: "#D9D9D9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7637 57.0737L76.5527 56.9531C76.6205 56.9908 76.6884 57.036 76.7562 57.0888L76.7637 57.0737Z",
    fill: "#C6C6C6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6513 62.349C63.4023 62.2056 63.1155 62.3113 63.0174 62.5905C62.9193 62.8697 63.0476 63.2168 63.2966 63.3602C63.5456 63.5035 63.8324 63.3979 63.9305 63.1187C64.0286 62.8395 63.9003 62.4999 63.6513 62.349Z",
    fill: "#374A57"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3622 59.3021C58.1132 59.1587 57.8265 59.2644 57.7284 59.5436C57.6303 59.8228 57.7585 60.1699 58.0076 60.3133C58.2566 60.4566 58.5433 60.351 58.6414 60.0718C58.7395 59.7926 58.6112 59.4455 58.3622 59.3021Z",
    fill: "#374A57"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0692 56.2435C52.8202 56.1002 52.5335 56.2058 52.4354 56.485C52.3373 56.7642 52.4656 57.1113 52.7146 57.2547C52.9636 57.3981 53.2504 57.2924 53.3484 57.0132C53.4465 56.734 53.3258 56.3944 53.0692 56.2435Z",
    fill: "#374A57"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7802 53.1927C47.5312 53.0494 47.2444 53.155 47.1463 53.4342C47.0482 53.7134 47.1765 54.0605 47.4255 54.2039C47.6745 54.3473 47.9613 54.2416 48.0594 53.9624C48.165 53.6832 48.0367 53.3361 47.7802 53.1927Z",
    fill: "#374A57"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M202.613 149.222L70.1953 61.778L201.983 60.9316L307.886 115.163V201.693L202.613 149.222Z",
    fill: "url(#paint0_linear_9008_207203)",
    fillOpacity: 0.6
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1953 62.1582L202.015 60.6953",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3145 62.1699L202.693 149.141",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3184 62.166L307.515 201.793",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3164 62.1641L308.477 114.801",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9008_207203",
    x1: 16.9035,
    y1: -34.9286,
    x2: 158.791,
    y2: 160.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96C6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96C6F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9008_207203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7608,
    height: 50.7608,
    fill: "white",
    transform: "translate(206.436 98.7188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9008_207203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7608,
    height: 50.7608,
    fill: "white",
    transform: "translate(231.436 113.719)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9008_207203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7608,
    height: 50.7608,
    fill: "white",
    transform: "translate(282.436 142.719)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_9008_207203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7608,
    height: 50.7608,
    fill: "white",
    transform: "translate(205.436 68.7188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_9008_207203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7608,
    height: 50.7608,
    fill: "white",
    transform: "translate(230.436 83.7188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_9008_207203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7608,
    height: 50.7608,
    fill: "white",
    transform: "translate(256.436 97.7188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_9008_207203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7608,
    height: 50.7608,
    fill: "white",
    transform: "translate(281.436 112.719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvBottle);
export default __webpack_public_path__ + "static/media/invBottle.de6e8f1d90e15a0fe975c467489dd45b.svg";
export { ForwardRef as ReactComponent };